import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Notification = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Notification",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 22 22"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3556 2.50937C11.3556 2.28846 11.1765 2.10938 10.9556 2.10938C10.7346 2.10938 10.5556 2.28846 10.5556 2.50937V3.74046C10.5259 3.74246 10.4962 3.74466 10.4667 3.74706C7.62404 3.97764 5.4 6.03263 5.4 8.53362L5.4 12.2406C5.4 13.3756 4.90456 14.4539 4.04348 15.1933L3.32811 15.8075C3.11983 15.9863 3 16.2471 3 16.5216C3 17.0415 3.42143 17.4629 3.94128 17.4629L8.60004 17.4629C8.60004 18.1059 8.8529 18.7225 9.30299 19.1771C9.75305 19.6317 10.3635 19.8871 11 19.8871C10.9999 19.8871 11 19.8871 11 19.8871C11.6365 19.8871 12.247 19.6317 12.6971 19.1771C13.1472 18.7225 13.4 18.1059 13.4 17.4629L18.0587 17.4629C18.5786 17.4629 19 17.0415 19 16.5216C19 16.2471 18.8802 15.9863 18.6719 15.8075L18.3924 15.5675C17.2546 14.5906 16.6 13.1657 16.6 11.6661V8.53362C16.6 6.00662 14.3295 3.93495 11.4444 3.74046C11.4149 3.73846 11.3852 3.73667 11.3556 3.73507V2.50937ZM10.9611 4.60402L10.6153 4.62733C8.07446 4.79862 6.28889 6.58791 6.28889 8.53362L6.28889 12.2406C6.28889 13.6348 5.68029 14.9595 4.62252 15.8677L3.90715 16.4819C3.89556 16.4918 3.88889 16.5063 3.88889 16.5216C3.88889 16.5506 3.91234 16.574 3.94128 16.574H18.0587C18.0877 16.574 18.1111 16.5506 18.1111 16.5216C18.1111 16.5063 18.1044 16.4918 18.0928 16.4819L17.8134 16.2419C16.4789 15.0962 15.7111 13.425 15.7111 11.6661V8.53362C15.7111 6.56843 13.8877 4.76146 11.3078 4.62268L10.9611 4.60402ZM9.39996 17.4629C9.39996 17.7913 9.49691 18.0968 9.66348 18.3518C9.72479 18.4457 9.79552 18.5327 9.87433 18.6115C10.1634 18.9006 10.561 19.0791 11 19.0791C10.9999 19.0791 11 19.0791 11 19.0791C11.4389 19.079 11.8366 18.9005 12.1257 18.6114C12.2044 18.5326 12.2751 18.4456 12.3364 18.3518C12.503 18.0968 12.6 17.7913 12.6 17.4629H9.39996Z"
      />
    </svg>
  );
};

